module.exports = __webpack_public_path__ + "Azure.jpg";